import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import './Map.css'
import Dropdown from 'react-bootstrap/Dropdown'
// import Dropdown from 'react-bootstrap/DropdownButton'

const Map = ({data}) => {


    console.log(data[0])

    const [center, setCenter] = useState({
        center:{
            lat: 9.0820, //lng:7.3986, lat:9.0765
            lng: 8.6753
        },
        zoom:5.2,
        covid:{
            active:data[2].totalCases_onAdmission,
            total: data[2].totalCases_labConfirmed,
            death:data[2].deaths,
            name:data[2].state
        }
    })

    // const [covid, setCovid] = useState({
        
    // })

    const AnyReactComponent = ({ text }) => (
            <>
                <div className='card  mapcard' >
                    <p>Confirmed cases: {center.covid.total} </p>
                    <p>Active cases: {center.covid.active}</p>
                    <p>Deaths: {center.covid.death} </p>
                    <p> {center.covid.name} </p>
                    {/* <div>{text} </div> */}
                </div>
                <div className='pin' ></div>
                <div className='pulse' ></div>
            </>
    );
    return (
        <div className='map' style={{ height: '100vh', width: '90%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyB05RrUefEB0tm_IIEsZln55bBq8KexG4k' }}
                defaultCenter={center.center}
                defaultZoom={center.zoom}
                >
                <AnyReactComponent
                    lat={center.center.lat}
                    lng={center.center.lng}
                   text='My marker'
                />
            </GoogleMapReact>
            <Dropdown className='mapbuttons' >
                <Dropdown.Toggle className='mapbuttons block'  variant="success" id="dropdown-basic">
                    Select state
                </Dropdown.Toggle>

                <Dropdown.Menu className='dropdownHeight' style={{height:300}} >
                    <Dropdown.Item>
                        <button className='block' onClick={() => {
                        setCenter({
                            center:{
                                lat: 6.2209,
                                lng: 6.9370
                            },
                            zoom:10,
                            covid:{
                                active:data[33].totalCases_onAdmission,
                                total: data[33].totalCases_labConfirmed,
                                death:data[33].deaths,
                                name:data[33].state
                            }
                        })
                        }} > {data[33].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{
                                lat: 5.7040,
                                lng: 5.9339
                            },
                            zoom:10,
                            covid:{
                                active:data[20].totalCases_onAdmission,
                                total: data[20].totalCases_labConfirmed,
                                death:data[20].deaths,
                                name:data[20].state
                            }
                        })
                        }}>{data[20].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button  onClick={() => {
                        setCenter({
                            center:{
                                lat: 12.2939,
                                lng: 11.439
                            },
                            zoom:10,
                            covid:{
                                active:data[17].totalCases_onAdmission,
                                total: data[17].totalCases_labConfirmed,
                                death:data[17].deaths,
                                name:data[17].state
                            }
                        })
                        }} >{data[17].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button  onClick={() => {
                        setCenter({
                            center:{
                                lat: 5.4527,
                                lng: 7.5248
                            },
                            zoom:10,
                            covid:{
                                active:data[34].totalCases_onAdmission,
                                total: data[34].totalCases_labConfirmed,
                                death:data[34].deaths,
                                name:data[34].state
                            }
                        })
                        }}>{data[34].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button  onClick={() => {
                        setCenter({
                            center:{
                                lat: 10.32,
                                lng: 9.83
                            },
                            zoom:10,
                            covid:{
                                active:data[9].totalCases_onAdmission,
                                total: data[9].totalCases_labConfirmed,
                                death:data[9].deaths,
                                name:data[9].state
                            }
                        })
                        }}>{data[9].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:6.26, lat: 4.92},
                            zoom:10,
                            covid:{
                                active:data[27].totalCases_onAdmission,
                                total: data[27].totalCases_labConfirmed,
                                death:data[27].deaths,
                                name:data[27].state
                            }
                        })
                        }}>{data[27].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.53, lat:7.73},
                            zoom:10,
                            covid:{
                                active:data[31].totalCases_onAdmission,
                                total: data[31].totalCases_labConfirmed,
                                death:data[31].deaths,
                                name:data[31].state
                            }
                        })
                        }}>{data[31].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:13.15, lat:11.83},
                            zoom:10,
                            covid:{
                                active:data[3].totalCases_onAdmission,
                                total: data[3].totalCases_labConfirmed,
                                death:data[3].deaths,
                                name:data[3].state
                            }
                        })
                        }}>{data[3].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.5988, lat:5.8702},
                            zoom:10,
                            covid:{
                                active:data[21].totalCases_onAdmission,
                                total: data[21].totalCases_labConfirmed,
                                death:data[21].deaths,
                                name:data[21].state
                            }
                        })
                        }}>{data[21].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:6.18, lat:6.75},
                            zoom:10,
                            covid:{
                                active:data[16].totalCases_onAdmission,
                                total: data[16].totalCases_labConfirmed,
                                death:data[16].deaths,
                                name:data[16].state
                            }
                        })
                        }}>{data[16].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.10, lat:6.33},
                            zoom:10,
                            covid:{
                                active:data[28].totalCases_onAdmission,
                                total: data[28].totalCases_labConfirmed,
                                death:data[28].deaths,
                                name:data[28].state
                            }
                        })
                        }}>{data[28].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button  onClick={() => {
                        setCenter({
                            center:{lng:5.60, lat:6.32},
                            zoom:10,
                            covid:{
                                active:data[10].totalCases_onAdmission,
                                total: data[10].totalCases_labConfirmed,
                                death:data[10].deaths,
                                name:data[10].state
                            }
                        })
                        }}>{data[10].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:5.22, lat:7.62},
                            zoom:10,
                            covid:{
                                active:data[24].totalCases_onAdmission,
                                total: data[24].totalCases_labConfirmed,
                                death:data[24].deaths,
                                name:data[24].state
                            }
                        })
                        }}>{data[24].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:7.50, lat:6.50},
                            zoom:10,
                            covid:{
                                active:data[26].totalCases_onAdmission,
                                total: data[26].totalCases_labConfirmed,
                                death:data[26].deaths,
                                name:data[26].state
                            }
                        })
                        }}>{data[26].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:11.17, lat:10.28},
                            zoom:10,
                            covid:{
                                active:data[4].totalCases_onAdmission,
                                total: data[4].totalCases_labConfirmed,
                                death:data[4].deaths,
                                name:data[4].state
                            }
                        })
                        }}>{data[4].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:7.02, lat:5.48},
                            zoom:10,
                            covid:{
                                active:data[32].totalCases_onAdmission,
                                total: data[32].totalCases_labConfirmed,
                                death:data[32].deaths,
                                name:data[32].state
                            }
                        })
                        }}>{data[32].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:9.5616, lat:12.2280},
                            zoom:10,
                            covid:{
                                active:data[13].totalCases_onAdmission,
                                total: data[13].totalCases_labConfirmed,
                                death:data[13].deaths,
                                name:data[13].state
                            }
                        })
                        }}>{data[13].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:3.4737, lat: 6.9980},
                            zoom:10,
                            covid:{
                                active:data[7].totalCases_onAdmission,
                                total: data[7].totalCases_labConfirmed,
                                death:data[7].deaths,
                                name:data[7].state
                            }
                        })
                        }}>{data[7].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 8.516667, lat: 12.0000},
                            zoom:10,
                            covid:{
                                active:data[1].totalCases_onAdmission,
                                total: data[1].totalCases_labConfirmed,
                                death:data[1].deaths,
                                name:data[1].state
                            }
                        })
                        }}>{data[1].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 11.8846, lat: 11.8846},
                            zoom:10,
                            covid:{
                                active:data[5].totalCases_onAdmission,
                                total: data[5].totalCases_labConfirmed,
                                death:data[5].deaths,
                                name:data[5].state
                            }
                        })
                        }}>{data[5].state}  </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 4.52, lat: 7.5629},
                            zoom:10,
                            covid:{
                                active:data[15].totalCases_onAdmission,
                                total: data[15].totalCases_labConfirmed,
                                death:data[15].deaths,
                                name:data[15].state
                            }
                        })
                        }}>{data[15].state}</button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.1997,lat:8.4998},
                            zoom:10,
                            covid:{
                                active:data[18].totalCases_onAdmission,
                                total: data[18].totalCases_labConfirmed,
                                death:data[18].deaths,
                                name:data[18].state
                            }
                        })
                        }}>{data[18].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 3.33, lat:6.58},
                            zoom:10,
                            covid:{
                                active:data[0].totalCases_onAdmission,
                                total: data[0].totalCases_labConfirmed,
                                death:data[0].deaths,
                                name:data[0].state
                            }
                        })
                        }}>{data[0].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:5.5949, lat:7.149},
                            zoom:10,
                            covid:{
                                active:data[25].totalCases_onAdmission,
                                total: data[25].totalCases_labConfirmed,
                                death:data[25].deaths,
                                name:data[25].state
                            }
                        })
                        }}>{data[25].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:7.0588, lat:5.572},
                            zoom:10,
                            covid:{
                                active:data[30].totalCases_onAdmission,
                                total: data[30].totalCases_labConfirmed,
                                death:data[30].deaths,
                                name:data[30].state
                            }
                        })
                        }}>{data[30].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:9.5616, lat:12.228},
                            zoom:10,
                            covid:{
                                active:data[6].totalCases_onAdmission,
                                total: data[6].totalCases_labConfirmed,
                                death:data[6].deaths,
                                name:data[6].state
                            }
                        })
                        }}>{data[6].state}  </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:12.3984, lat:9.32},
                            zoom:10,
                            covid:{
                                active:data[23].totalCases_onAdmission,
                                total: data[23].totalCases_labConfirmed,
                                death:data[23].deaths,
                                name:data[23].state
                            }
                        })
                        }}>{data[23].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:4.57, lat:7.77},
                            zoom:10,
                            covid:{
                                active:data[14].totalCases_onAdmission,
                                total: data[14].totalCases_labConfirmed,
                                death:data[14].deaths,
                                name:data[14].state
                            }
                        })
                        }}>{data[14].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:3.90, lat:7.38},
                            zoom:10,
                            covid:{
                                active:data[11].totalCases_onAdmission,
                                total: data[11].totalCases_labConfirmed,
                                death:data[11].deaths,
                                name:data[11].state
                            }
                        })
                        }}>{data[11].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.90, lat:9.92},
                            zoom:10,
                            covid:{
                                active:data[29].totalCases_onAdmission,
                                total: data[29].totalCases_labConfirmed,
                                death:data[29].deaths,
                                name:data[29].state
                            }
                        })
                        }}>{data[29].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:4.5983, lat:9.9309},
                            zoom:10,
                            covid:{
                                active:data[21].totalCases_onAdmission,
                                total: data[21].totalCases_labConfirmed,
                                death:data[21].deaths,
                                name:data[21].state
                            }
                        })
                        }}>{data[21].state}  </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 7.7095, lat: 10.3764},
                            zoom:10,
                            covid:{
                                active:data[8].totalCases_onAdmission,
                                total: data[8].totalCases_labConfirmed,
                                death:data[8].deaths,
                                name:data[8].state
                            }
                        })
                        }}>{data[8].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:11.37, lat:8.90},
                            zoom:10,
                            covid:{
                                active:data[19].totalCases_onAdmission,
                                total: data[19].totalCases_labConfirmed,
                                death:data[19].deaths,
                                name:data[19].state
                            }
                        })
                        }}>{data[19].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng:8.8583, lat:9.8965},
                            zoom:10,
                            covid:{
                                active:data[22].totalCases_onAdmission,
                                total: data[22].totalCases_labConfirmed,
                                death:data[22].deaths,
                                name:data[22].state
                            }
                        })
                        }}>{data[22].state}  </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                        <button onClick={() => {
                        setCenter({
                            center:{lng: 6.2236, lat: 12.1222},
                            zoom:10,
                            covid:{
                                active:data[12].totalCases_onAdmission,
                                total: data[12].totalCases_labConfirmed,
                                death:data[12].deaths,
                                name:data[12].state
                            }
                        })
                        }}>{data[12].state} </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                    <button onClick={() => {
                    setCenter({
                        center:{lng:7.3986, lat:9.0765},
                        zoom:10,
                        covid:{
                            active:data[2].totalCases_onAdmission,
                            total: data[2].totalCases_labConfirmed,
                            death:data[2].deaths,
                            name:data[2].state
                        }
                    })
                    }}> {data[2].state} </button>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <div className='mapbuttons' >


                {/* <button onClick={() => {
                    setCenter({
                        center:{lng:6.82, lat:7.75},
                        zoom:10
                    })
                }}>Kogi</button> */}







            </div>
        </div>
    )
}

export default Map;